module.exports = "<div [id]=\"scrollTargetId\" style=\"overflow-x: auto; overflow-y: hidden;\">\r\n  <div [id]=\"scrollTargetContentId\" style=\"height: 1px;\"></div>\r\n</div>\r\n<div [class]=\"className\" [id]=\"scrollSourceId\" #scrollSource>\r\n  <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/double-scroll.component/double-scroll.component.html
// module id = bpH7
// module chunks = 1